import React, { useContext, useEffect, useState } from "react";
import {
  AppBar,
  Drawer,
  ListItem,
  ListItemText,
  Toolbar,
  List,
  Typography,
  IconButton,
  Badge,
  Stack,
  Avatar,
  Paper,
  InputBase,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import styled, { keyframes } from 'styled-components';
import PICON from "../../../icons/PICON.svg"
import notification from '../../../icons/notification.svg'
import { getNavItems } from "../../header";
import { NavLink } from "react-router-dom";
import { PRIMARY_COLOR } from "../../../constants";
import { Fab } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight, Search } from "@mui/icons-material";
import { AuthContext } from "../../contextAPI/ContextAPI";

const isMobile = window.innerWidth < 900;

const LogoContainer = styled.div`
  background-color: ${(props) =>
    props.drawerOpen ? "white" : isMobile ? "unset" : "white"};

  padding: ${(props) => (props.drawerOpen ? "0px" : isMobile ? "0px" : "10px")};

  border-radius: ${(props) =>
    props.drawerOpen ? (isMobile ? "20px" : "0px") : "0px"};
`;

const Logo = styled.img`
  width: 100%;

  margin-top: ${(props) =>
    props.drawerOpen ? (isMobile ? "15px" : "0px") : "0px"};

  padding: ${(props) =>
    props.drawerOpen ? (isMobile ? "0px" : "15px") : "0px"};

  height: ${(props) =>
    props.drawerOpen ? (isMobile ? "auto" : "60px") : "30px"};
`;

const DrawerContentContainer = styled.div`
  height: 100vh;
  background: ${PRIMARY_COLOR};
  transition: all 0.2s;
  border-radius: ${(props) => (props.drawerOpen ? "20px" : "10px")};
  overflow:hidden;
  border:1px solid ${PRIMARY_COLOR};
`;

const DrawerListsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 85px);
`;
const DrawerLink = styled(NavLink)`
  border-left: 5px solid transparent;
  transition: all 0.2s;
  &:hover,
  &.active {
    border-left: 5px solid white;
    ${props => props.isMobile && "border-radius:10px;"}
    ${props => props.isMobile && "background: white;"}
   i, span{
    // color: ${props => props.isMobile ? PRIMARY_COLOR : 'white'} !important;
  }
  }
`;
const DrawerItemIcon = styled.i`
  color:white;
`;
const DrawerItemText = styled(ListItemText)`
margin-left: 16;
color:white;
`;
const DrawerAction = styled(ListItem)`
  gap:10px;
  border-left: 5px solid transparent;
  transition: all 0.2s;
  &:hover,
  &.active {
    border-left: 5px solid white;
    ${props => props.isMobile && "border-radius:10px;"}
    ${props => props.isMobile && "background: white;"}
   i, span{
    color: ${props => props.isMobile ? PRIMARY_COLOR : 'white'} !important;
  }
  }
`;
const MarqueeContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

const marqueeLeftRight = keyframes`
  0%, 100% {
    transform: translateX(100%);
  }
  50% {
    transform: translateX(-100%);
  }
`;

const MarqueeText = styled.span`
  color: #21225F;
  display: inline-block;
  animation: ${marqueeLeftRight} 15s linear infinite;
`;
const drawerWidth = 240;
const ComponentWrapper = (props) => {
  const { auth, setAuth } = useContext(AuthContext)
  const initialDrawerState = JSON.parse(localStorage.getItem('isDrawerOpen'))
  const [drawerOpen, setDrawerOpen] = useState(isMobile ? false : initialDrawerState);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    async function fetchRoles() {
      try {
        let results = await window.Platform.database.fetchRoles();
        setRoles(results?.data || []);
      } catch (err) {
        setRoles([]);
      }
    }
    fetchRoles();
  }, []);

  const navItems = getNavItems();

  const onClickLogout = async () => {
    try {
      await window.Platform.database.signOut();
      auth.onAuthUserChanged && auth.onAuthUserChanged();
      console.log("auth", auth)
    } catch (error) {
      window.NotificationUtils.showError("Something Went Wrong");
    }
  };

  const getUserName = () => {
    let result = "";
    if (auth.user) {
      result = auth.user.user?.username || "";
    }
    let length = 25;
    if (result.length > length && isMobile) {
      result = result.slice(0, length - 3) + "...";
    }
   let a= result.split('')
   a[0]=a[0]?.toUpperCase();
   result=a.join('')
    return result;
  };

  const getUserRole = () => {
    let roleKey = auth.user?.user?.role || "";
    let found = roles.find(r => r.roleName === roleKey);
    let result = found ? found.name : roleKey;
    let length = 25;
    if (result.length > length && isMobile) {
      result = result.slice(0, length - 3) + "...";
    }
    let a = result.split('')
    a[0] = a[0]?.toUpperCase();
    result = a.join('')
    return result;
  };

  const getNotificationCount = () => {
    let result = Number(
      auth.user?.notifications ? auth.user?.notifications.length : 0
    );
    return result;
  };

  const renderDrawerContent = () => {
    return (
      <DrawerContentContainer drawerOpen={drawerOpen}>
        <NavLink to={"/dashboard"}>
          <LogoContainer drawerOpen={drawerOpen}>
            <Logo
              drawerOpen={drawerOpen}
              src={
                drawerOpen
                  ? "logo1.png"
                  : isMobile
                    ? "logo1.png"
                    : "logo512.png"
              }
            />
          </LogoContainer>
        </NavLink>

        <DrawerListsContainer>
          <List>
            {navItems.map((navItem) => {
              return (
                <DrawerLink
                  isMobile={isMobile}
                  key={navItem.title}
                  to={navItem.link}
                  className={"nav-link"}
                >
                  <ListItem style={{ gap: '10px' }}>
                    <DrawerItemIcon
                      className="icon material-icons" as={navItem.icon}
                    >

                    </DrawerItemIcon>
                    {drawerOpen && (
                      <DrawerItemText
                        primary={navItem.title}
                      />
                    )}
                  </ListItem>
                </DrawerLink>
              );
            })}
          </List>

          <List style={{ marginBottom: 10, width: "100%" }}>
            <DrawerAction
              isMobile={isMobile}
              className="nav-link"
              onClick={onClickLogout}
              style={{ cursor: "pointer" }}
            >
              <DrawerItemIcon className="icon material-icons" >
                {"power_settings_new"}
              </DrawerItemIcon>
              {drawerOpen && (
                <DrawerItemText
                  primary={"Logout"}
                />
              )}
            </DrawerAction>
          </List>
        </DrawerListsContainer>
      </DrawerContentContainer>
    );
  };

  useEffect(() => {
    localStorage.setItem('isDrawerOpen', drawerOpen)
    // console.log("checkAuth", auth)
  }, [drawerOpen])

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      {/* <Drawer
        style={{
          width: drawerOpen ? "240px" : "80px",
          transition: "all 0.2s",
        }}
        variant={isMobile ? "temporary" : "permanent"}
        sx={{
          width: drawerOpen ? "240px" : "80px",
          "& .MuiDrawer-paper": {
            padding: "10px",
            border: "none",
            background: isMobile ? PRIMARY_COLOR : "none",
            overflow: "visible",
            width: drawerOpen ? "240px" : "80px",
            transition: "all 0.2s",
          },
        }}
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        {!isMobile && (
          <Fab
            onClick={() => setDrawerOpen((prev) => !prev)}
            size="small"
            sx={{
              position: "absolute",
              right: "-7px",
              top: "180px",
              zIndex: "5",
              borderRadius: "40px",
              width: "40px",
              height: "40px",
              boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 26%)",
              // background: ,
              color: PRIMARY_COLOR,
              transition: "all 0.2s",
            }}
          >
            {drawerOpen ? (
              <KeyboardArrowLeft sx={{ fontSize: "28px" }} />
            ) : (
              <KeyboardArrowRight sx={{ fontSize: "28px" }} />
            )}
          </Fab>
        )}
        {renderDrawerContent()}
      </Drawer> */}
{/* rs header */}
      <div style={{ width: "100%" }}>
        <AppBar
          position="sticky"
          style={{ boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px", background: "white", top: "0", left: "0" }}
        >

          <Toolbar>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              {isMobile && (
                <IconButton onClick={() => setDrawerOpen(true)}>
                  <MenuIcon />
                </IconButton>
              )}
              {/* <Paper
    // component="form"
    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, border:"none" }}
  > */}
              {/* <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                <Search />
              </IconButton> */}
              <div>
                
              </div>
              {/* <InputBase
      classes={{ root: 'no-border' }} // Apply a custom class
      sx={{
        ml: 1,
        flex: 1,
      }}
      placeholder="Search "
      inputProps={{ 'aria-label': 'search' }}
    /> */}

              {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}
              {/* <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions"> */}
              {/* <DirectionsIco /> */}
              {/* </IconButton> */}
              {/* </Paper> */}
              <div style={{ display: "flex" }}>

                <IconButton onClick={() => auth.setShowNotifications(true)}>
                  <Badge
                    color="primary"
                    badgeContent={getNotificationCount()}
                    max={9}
                  >
                    <img src={notification} alt="icon"  height={"22"} width={"22"}/>
                  </Badge>
                </IconButton>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
                  <img src={PICON} alt="icon" height={"25"} width={"25"}/>
                  <div>
                    <Typography style={{color:"black"}} fontSize={"16px"} fonColor={"black"} fontWeight={"500"}>{getUserName()}</Typography>
                    <Typography  style={{color:"black"}}  fontSize={"12px"} fontColor={"black"} fontWeight={"500"}>{getUserRole()}</Typography>
                  </div>
                </Stack>

              </div>

            </div>
          </Toolbar>
        </AppBar>
        <div>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default ComponentWrapper;
